import { createSlice } from '@reduxjs/toolkit';
import {
  checkVerificationCodeBuilder,
  createInfluencerRequestBuilder,
  fetchUserInfoBuilder,
  loginBuilder,
  requestVerificationCodeBuilder,
  resetPasswordBuilder,
  verifyEmailBuilder,
} from './builder';
import { LOGOUT } from '../../../utils/constants';

const INIT_STATE = {
  isLoggedIn: null,
  accessToken: null,
  signUpFormData: null,
  pending: {
    login: false,
    requestVerificationCode: false,
    checkVerificationCode: false,
    resetPassword: false,
    verifyEmail: false,
    createInfluencerRequest: false,
  },
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: INIT_STATE,
  reducers: {
    setAccessToken: (state, { payload }) => {
      const { accessToken } = payload;
      state.accessToken = accessToken;
    },
    setSignUpFormData: (state, { payload }) => {
      state.signUpFormData = payload;
    },
  },
  extraReducers: builder => {
    loginBuilder(builder);
    fetchUserInfoBuilder(builder);
    requestVerificationCodeBuilder(builder);
    checkVerificationCodeBuilder(builder);
    resetPasswordBuilder(builder);
    verifyEmailBuilder(builder);
    createInfluencerRequestBuilder(builder);
    builder.addCase(LOGOUT, () => ({ ...INIT_STATE, isLoggedIn: false }));
  },
});

export const { setAccessToken, setSignUpFormData } = authSlice.actions;

export const selectIsLoggedIn = state => state.auth.isLoggedIn;
export const selectAccessToken = state => state.auth.accessToken;
export const selectAuthActionsPending = state => state.auth.pending;
export const selectSignUpFormData = state => state.auth.signUpFormData;

export default authSlice.reducer;
